import React, { useCallback } from 'react';

const StepButtons = ({
    step,
    setStep,
    captchaValue,
    nextStepAction,
    isSubmitting = false,
}) => {
    const isLastStep = step === 4;
    const isNextDisabled =
        isSubmitting || (isLastStep && captchaValue === null);

    const nextStep = () => {
        switch (step) {
            case 4:
                return (
                    <button
                        type="button"
                        id="lastButtonSubmit"
                        disabled={isNextDisabled}
                        className={
                            'c-btn o-button-container__button ' +
                            (isNextDisabled ? 'button-disabled' : '')
                        }
                        onClick={() => {
                            if (!isNextDisabled) {
                                nextStepAction();
                            }
                        }}
                    >
                        <span className="c-btn__text">Finalizar</span>
                    </button>
                );
            default:
                return (
                    <button
                        type="button"
                        disabled={isNextDisabled}
                        className="c-btn o-button-container__button"
                        onClick={() => {
                            if (!isNextDisabled) {
                                nextStepAction();
                            }
                        }}
                    >
                        <span className="c-btn__text">Siguiente</span>
                    </button>
                );
        }
    };

    const handleBackButton = useCallback(() => {
        switch (step) {
            default:
                setStep(step - 1);
                break;
        }
    }, [setStep, step]);

    return (
        <div className="o-fieldset u-mt-large">
            <div className="o-fieldset__row">
                <div className="o-button-container  o-button-container--nav">
                    <button
                        type="button"
                        disabled={isSubmitting}
                        className="c-btn c-btn--secondary o-button-container__button"
                        onClick={() => handleBackButton()}
                    >
                        <i className="c-icon c-icon--[semantic-back] c-icon--small"></i>
                        <span className="c-btn__text">Volver</span>
                    </button>
                    {nextStep()}
                </div>
            </div>
        </div>
    );
};

export default StepButtons;
